import { useState, useEffect, useCallback } from "react";
import { ErrorMessage, useFormikContext } from "formik";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { styled } from "@mui/material/styles";
import { resetLinkedList, titleCase } from "../../CommonFuntion/SchemaValidation";

const CssSelectField = styled(Select)({
  ".MuiSelect-select": {},
  "& label.Mui-focused": {
    color: "#ec0000c4",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#ec0000c4",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#ec0000c4",
    },
    "&:hover fieldset": {
      borderColor: "#ec0000c4",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#ec0000c4",
    },
  },
  "& div.MuiSelect-nativeInput": {
    fontSize: 12,
  },
});

export function ELCSelectDropDown(props) {
  const {
    elementName,
    name,
    label,
    options,
    tagName,
    prefix,
    validation,
    schemaPageId,
    schemaResult,
    schemaItem,
    mandatoryByLabelName,
    disableByLabelName,
    ELLValue,
  } = props;
  const [options2, setOptions2] = useState(options);
  const { setFieldValue, values } = useFormikContext();

  useEffect(() => {
    if (ELLValue) {
      const parentPageId = parseInt(elementName.parentId?.split("|")?.[0]);
      const parentId = parseInt(elementName.parentId?.split("|")?.[1]);

      let schema = {};
      let dropDownValue = "";
      if (parentPageId === schemaPageId && elementName.lists) {
        schema = schemaResult?.find((x) => x.schemaItem === parentId);
        dropDownValue = values?.[schema?.fieldName];
        dropDownValue = schema?.options.find(
          (x) => x.label === dropDownValue
        )?.value;
      }
      if (dropDownValue) {
        for (const [key, value] of Object.entries(elementName.lists)) {
          if (parseInt(key) === parseInt(dropDownValue)) {
            setOptions2(value);
            break;
          }
        }
      }
    }
  }, [ELLValue, elementName, schemaPageId, schemaResult]);

  const id = `${tagName}-input`;
  const handleChange = useCallback(
    (e) => {
      setFieldValue(name, e.target.value || "");
      resetLinkedList(
        schemaResult,
        schemaPageId,
        schemaItem,
        values,
        setFieldValue
      );
    },
    [name, setFieldValue, values]
  );

  return (
    <>
      <div className="flex-container">
        <div className="control-bottom-border">
          {label && (
            <label className="font-css" id={id}>
              {titleCase(label.replace("_", " "))}

              {(validation?.mandatory ||
                (validation?.mandatoryByLabelName &&
                  validation?.mandatoryByLabelName ===
                    mandatoryByLabelName)) && (
                <span className="mandatory-validation">{"*"}</span>
              )}
            </label>
          )}
        </div>

        <div className="control-bottom-border">
          <FormControl variant="standard" aria-labelledby={id}>
            <CssSelectField
              labelId={id}
              id={tagName}
              name={name}
              key={name}
              tagname={tagName}
              fieldname={name}
              prefix={prefix}
              className="control-width-font"
              style={{
                fontSize: "12px",
              }}
              onChange={handleChange}
              label={titleCase(label.split(" ")[0].replace("_", " "))}
              value={values[name] || ""}
              disabled={
                validation?.disableByLabelName &&
                validation?.disableByLabelName === disableByLabelName
              }
            >
              <MenuItem
                style={{
                  fontSize: "12px",
                }}
                value=""
                key="empty"
              ></MenuItem>
              {options2.map((optn, index) => (
                <MenuItem
                  style={{
                    fontSize: "12px",
                  }}
                  key={index}
                  value={optn.value}
                >
                  {optn.label}
                </MenuItem>
              ))}
            </CssSelectField>
          </FormControl>
          <ErrorMessage
            name={name}
            render={(msg) => <div className="is-invalid">{msg}</div>}
          />
        </div>
      </div>
    </>
  );
}
